import styled from 'styled-components';

export const GrowthWidgetCard = styled.div`
  height: 100%;
  padding: 20px 22px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 8px 16px 0 #dddddd52;
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: visible;
`;

export const GrowthWidgetHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  height: 40px;
  min-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  overflow: hidden;

  img.widgetIcon {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    object-fit: contain;
    margin-top: 2px;
  }

  .title {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    max-height: 40px;
    color: #2f3d48;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    @media (min-width: 1800px) {
      font-size: clamp(16px, 1vw, 22px);
    }
  }

  &.withInfoPadding {
    padding-right: 36px;
  }
`;

export const GrowthWidgetInfo = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 30;

  .DropInfo,
  .DropInfo.DropInfoMainPage {
    right: 0;
    left: auto;
    width: 320px;
    max-width: 320px;
    top: auto;
    bottom: calc(100% + 8px);
    padding: 16px 20px;
    font-size: 13px;
    line-height: 1.45;
    z-index: 30;

    &::after {
      right: 6px;
      left: auto;
      bottom: inherit;
      top: 100%;
      transform: rotate(180deg);
    }

    &.LeftSide {
      left: -280px;
    }

    @media (max-width: 767px) {
      width: 260px;
      max-width: 260px;
      padding: 12px 14px;
      font-size: 12px;
      &.LeftSide {
        left: -220px;
      }
    }
  }
`;

export const GrowthWidgetMetric = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  height: 46px;
  font-weight: 100;
  font-size: 42px;
  line-height: 46px;
  color: #2f3d48;

  &.muted {
    color: #b3b9c2;
  }

  .trend {
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    color: #17c981;
    @media (min-width: 1800px) {
      font-size: clamp(16px, 1vw, 22px);
    }
  }

  .trend.negative,
  .trend.flat {
    color: #929cb9;
  }

  @media (min-width: 1800px) {
    font-size: clamp(42px, 1vw, 48px);
  }
`;

export const GrowthWidgetHint = styled.div`
  display: block;
  box-sizing: border-box;
  align-self: stretch;
  width: auto;
  margin-top: 14px;
  margin-left: -22px;
  margin-right: -22px;
  padding: 10px 22px;
  background-color: #f4f5f7;
  border-radius: 0;
  font-size: 12px;
  line-height: 1.4;
  color: #2f3d48;

  @media (min-width: 1800px) {
    font-size: clamp(12px, 1vw, 18px);
  }
`;

export const GrowthWidgetFooter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px 40px;
  margin-top: auto;
  padding-top: 24px;

  span {
    font-size: 14px;
    font-weight: 700;
    color: #ff2d38;
    cursor: pointer;
    @media (min-width: 1800px) {
      font-size: clamp(14px, 1vw, 20px);
    }
  }

  &.buttonsGroup {
    gap: 16px 40px;
  }

  &.secondary span:last-child {
    color: #2f3d48;
  }
`;

export const GrowthWidgetSplit = styled.div`
  display: flex;
  align-items: stretch;
  gap: 24px;
  flex: 1 1 auto;
  min-height: 0;

  &.withInfo {
    padding-right: 36px;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 20px;

    &.withInfo {
      padding-right: 0;
    }
  }
`;

export const GrowthWidgetColumn = styled.div`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;

  ${GrowthWidgetMetric} {
    margin-top: 12px;
  }

  ${GrowthWidgetFooter} {
    margin-top: auto;
    padding-top: 24px;
  }
`;
export const GrowthPromoCard = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 0 0 22px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 8px 16px 0 #dddddd52;
  position: relative;
  box-sizing: border-box;
`;

export const GrowthPromoHeader = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 13px;
  padding-right: 20px;
`;

export const GrowthPromoBadge = styled.span`
  border-radius: 25px;
  padding: 2px 8px;
  color: #ffffff;
  background-color: #17c981;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  box-shadow: 0 5px 10px 0 #00000033;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const GrowthPromoBody = styled.div`
  display: flex;
  flex: 1;
`;

export const GrowthPromoLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 1 auto;
  margin-right: 100px;

  @media (max-width: 1400px) {
    margin-right: 48px;
  }
  @media (max-width: 550px) {
    margin-right: 40px;
  }
`;

export const GrowthPromoRight = styled.div`
  max-width: 130px;
  min-width: 100px;
  width: 22.5%;
  display: flex;
  align-items: flex-end;
  flex: 0 0 auto;

  img {
    width: 100%;
  }

  @media (min-width: 1800px) {
    min-width: 200px;
    max-width: 250px;
  }
`;

export const GrowthPanel = styled.div`
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 8px 16px 0 #dddddd52;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const GrowthPanelSections = styled.div`
  display: flex;
  align-items: stretch;
  min-height: 0;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const GrowthPanelSection = styled.div`
  flex: 1 1 0;
  min-width: 0;
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  border-left: 1px solid #eef0f4;
  box-sizing: border-box;

  &:first-child {
    border-left: none;
  }

  @media (max-width: 900px) {
    border-left: none;
    border-top: 1px solid #eef0f4;
    &:first-child {
      border-top: none;
    }
  }
`;

export const GrowthPanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .icon {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    object-fit: contain;
  }

  .title {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: #2f3d48;
  }
`;

export const GrowthPanelMetric = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  font-size: 46px;
  font-weight: 300;
  line-height: 1;
  color: #2f3d48;

  .delta {
    font-size: 17px;
    font-weight: 600;
    line-height: 1;
    color: #17c981;
  }

  .delta.negative,
  .delta.flat {
    color: #929cb9;
  }
`;

export const GrowthPanelLink = styled.button.attrs({type: 'button'})`
  margin-top: auto;
  padding: 0;
  border: 0;
  background: none;
  font-size: 14px;
  font-weight: 700;
  color: #ff2d38;
  cursor: pointer;
  text-align: left;

  &:focus-visible {
    outline: 2px solid #ff2d38;
    outline-offset: 2px;
  }
`;

export const GrowthPanelPill = styled.div`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 9px;
  padding: 13px 28px;
  background-color: #f4f5f7;
  border-radius: 999px;
  font-size: 14px;
  line-height: 15px;
  color: #6b7280;

  .pillIcon {
    display: block;
    width: 15px;
    height: 15px;
    flex-shrink: 0;
  }
`;
